import React from 'react';
import { PreferMonthlyBilling } from './OffersComponents/PreferMonthlyBilling';
import { TooExpensive } from './OffersComponents/TooExpensive';
import { NotUsingTheToolAsMuchForNow } from './OffersComponents/NotUsingTheToolAsMuchForNow';
import { FindingHardToUse } from './OffersComponents/FindingHardToUse';
import { FacingBugs } from './OffersComponents/FacingBugs';
import { HiringSomeoneToDoItForMeInstead } from './OffersComponents/HiringSomeoneToDoItForMeInstead';
import { MissingFeatures } from './OffersComponents/MissingFeatures';
import { OtherReason } from './OffersComponents/OtherReason';

interface OfferComponentRendererProps {
  selectedOption: string;
  selectedTimeLine: string;
  handCloseModal: () => void;
  handleChangePlanModal: () => void;
  isFromDeactivate: boolean;
  setIsOfferApplied: (val: boolean) => void;
  facingBugsState: {
    isFacingBugsFieldErrorFromOfferModal: boolean | null;
    setIsFacingBugsFieldErrorFromOfferModal: (val: boolean | null) => void;
    isMinCharFacingBugsErrorFromOfferModal: boolean | null;
    setIsMinCharFacingBugsErrorFromOfferModal: (val: boolean | null) => void;
    facingBugsFeatureFromOfferModal: string;
    setFacingBugsFeatureFromOfferModal: (val: string) => void;
  };
  missingFeature: string;
  otherReason: string;
}

const OfferComponentRenderer: React.FC<OfferComponentRendererProps> = ({
  selectedOption,
  selectedTimeLine,
  handCloseModal,
  handleChangePlanModal,
  isFromDeactivate,
  setIsOfferApplied,
  facingBugsState,
  missingFeature,
  otherReason
}) => {
  switch (selectedOption) {
    case 'Prefer Monthly Billing':
      return (
        <PreferMonthlyBilling
          selectedTimeLine={selectedTimeLine}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          isFromDeactivate={isFromDeactivate}
          setIsOfferApplied={setIsOfferApplied}
        />
      );
    case 'Too expensive':
      return (
        <TooExpensive
          isFromDeactivate={isFromDeactivate}
          selectedTimeLine={selectedTimeLine}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          setIsOfferApplied={setIsOfferApplied}
        />
      );
    case 'Not using the tool as much for now':
      return (
        <NotUsingTheToolAsMuchForNow
          isFromDeactivate={isFromDeactivate}
          selectedTimeLine={selectedTimeLine}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          setIsOfferApplied={setIsOfferApplied}
        />
      );
    case 'Finding hard to use':
      return (
        <FindingHardToUse
          selectedTimeLine={selectedTimeLine}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
        />
      );
    case 'Facing bugs':
      return (
        <FacingBugs
          isFromDeactivate={isFromDeactivate}
          selectedTimeLine={selectedTimeLine}
          handCloseModal={handCloseModal}
          handleChangePlanModal={handleChangePlanModal}
          isFacingBugsFieldErrorFromOfferModal={facingBugsState.isFacingBugsFieldErrorFromOfferModal}
          setIsFacingBugsFieldErrorFromOfferModal={facingBugsState.setIsFacingBugsFieldErrorFromOfferModal}
          isMinCharFacingBugsErrorFromOfferModal={facingBugsState.isMinCharFacingBugsErrorFromOfferModal}
          setIsMinCharFacingBugsErrorFromOfferModal={facingBugsState.setIsMinCharFacingBugsErrorFromOfferModal}
          facingBugsFeatureFromOfferModal={facingBugsState.facingBugsFeatureFromOfferModal}
          setFacingBugsFeatureFromOfferModal={facingBugsState.setFacingBugsFeatureFromOfferModal}
          setIsOfferApplied={setIsOfferApplied}
        />
      );
    case 'Hiring someone to do it for me instead':
      return (
        <HiringSomeoneToDoItForMeInstead
          selectedTimeLine={selectedTimeLine}
        />
      );
    case 'Missing Features':
      return <MissingFeatures missingFeature={missingFeature} />;
    case 'Other':
      return <OtherReason otherReason={otherReason} />;
    default:
      return null;
  }
};

export default OfferComponentRenderer;
